import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featured = getFeaturedArticles().slice(0, 3);
  const mainArticle = featured[0];
  const sideArticles = featured.slice(1, 3);

  return (
    <section className="relative w-full bg-background-900 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20abstract%20background%20with%20subtle%20warm%20red%20and%20amber%20gradients%20floating%20particles%20mysterious%20entertainment%20atmosphere%20soft%20bokeh%20effect%20clean%20composition%20editorial%20quality&width=1600&height=600&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-900"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {mainArticle && (
            <Link to={`/article/${mainArticle.slug}`} className="lg:col-span-2 group cursor-pointer block">
              <div className="relative aspect-[16/9] rounded-xl overflow-hidden mb-4">
                <img
                  src={mainArticle.image}
                  alt={mainArticle.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block bg-primary-500 text-white text-xs px-3 py-1 rounded-full mb-3">
                    热门推荐
                  </span>
                  <h2 className="font-heading text-2xl md:text-3xl text-white leading-tight mb-2 group-hover:text-accent-300 transition-colors duration-200">
                    {mainArticle.title}
                  </h2>
                  <p className="text-sm text-white/70 line-clamp-2">{mainArticle.excerpt}</p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-white/60">
                    <span>{mainArticle.date}</span>
                    <span>{mainArticle.views >= 10000 ? `${(mainArticle.views / 10000).toFixed(1)}万` : mainArticle.views} 次阅读</span>
                  </div>
                </div>
              </div>
            </Link>
          )}
          <div className="flex flex-col gap-4">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group flex gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/15 transition-all duration-200 cursor-pointer"
              >
                <div className="w-28 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm text-white leading-snug line-clamp-2 group-hover:text-accent-300 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-xs text-white/60 mt-2">{article.date}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}